/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Malsha Samarakoon
 * @Date 30/9/2024
 */

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  savedAddress: null,
};

const addressSlice = createSlice({
  name: "address",
  initialState,
  reducers: {

    saveAddressDetails: (state, action) => {
      // console.log("Reducer payload:", action.payload);
      state.savedAddress = action.payload;
    },

  },
});

export const { saveAddressDetails } = addressSlice.actions;
export default addressSlice.reducer;
